import humps from "humps"
import { axiosPrivate } from "../../../api/axios"

export const getData = async (url: string, setData: any, setLoading?: any) => {
  await axiosPrivate
    .get(url)
    .then((response: any) => {
      setData ? setData(response.data) : null; // This doesn't seem to want to work
      setLoading ? setLoading(false) : null;

      return response.data;
    })
    .catch(error => {
      setLoading ? setLoading(false) : null
      console.error('getData error:', error, ' code:', error?.response?.status)
      if (error?.response?.status === 500 || error?.response?.status === 401) {
        sessionStorage.clear()
        window.location.reload();
      }

      return null;
    })
}

export const getDataWithParams = async (url: string, params: any, setData: any, setLoading?: any) => {
  await axiosPrivate
    .get(url, { params: humps.decamelizeKeys(params) })
    .then((response: any) => {
      setData(response.data)
      setLoading ? setLoading(false) : null
      return response.data
    })
    .catch(error => {
      setLoading ? setLoading(false) : null
      console.error('getDataWithParams error:', error, ' code:', error?.response?.status)
      if (error?.response?.status === 500 || error?.response?.status === 401) {
        sessionStorage.clear()
        window.location.reload();
      }
    })
}

export const postData = async (url: string, payload: any, setData?: any, setLoading?: any) => {
  try {
    const response = await axiosPrivate.post(url, payload);
    setLoading && setLoading(false);
    setData && setData(response.data);
    return response.data;
  } catch (error) {
    setData && setData([]);
    setLoading && setLoading(false);
    console.error(error);
    return [];
  }
};


export const postDataWithParams = async (url: string, params: any, payload: any, setData?: any, setLoading?: any) => {
  const urlWithParams = new URL(url, window.location.origin);

  // Append params to URL
  Object.keys(params).forEach(key => urlWithParams.searchParams.append(key, params[key]));

  await axiosPrivate
    .post(urlWithParams.toString(), payload)
    .then((response) => {
      if (setLoading) setLoading(false);
      if (setData) setData(response.data);
      return response.data;
    })
    .catch((error) => {
      if (setData) setData([]);
      if (setLoading) setLoading(false);
      console.error(error);
      return [];
    });
};


export const postDataWithDeCamelize = async (url: string, payload: any, setData?: any) => {
  await axiosPrivate
    .post(url, humps.decamelizeKeys(payload))
    .then((response) => {
      setData(response.data)
    })
    .catch((error) => {
      console.error(error)
    })
}

export const getUserById = async(userId: string, setData: any) => {
  await axiosPrivate
    .get(`rest/get_user/${userId}`)
    .then((response: any) => {
      setData(response.data)
      return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export const getUserByLongId = async(userId: number, setData: any) => {
  await axiosPrivate
    .get(`rest/get_user_details/${userId}`)
    .then((response: any) => {
      setData(response.data)
      return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// export const getLoggedInUserData = async(setData: any) => {
//   console.log("Asd")

//   await axiosPrivate
//     .get("rest/get_user_info")
//     .then((response: any) => {
//       console.log(response.data)

//       setData(response.data)
//       return response.data
//     })
//     .catch((error) => {
//       console.log(error)
//     })
// }


export const getUserNameById = (id: string, setData: any) => {
  getUserById(id, setData)
}
